(() => {
  function scrollActiveCategoryIntoView(section, activeButton, behavior = 'smooth') {
    if (!activeButton || typeof activeButton.scrollIntoView !== 'function') return;

    const categoryList = section.querySelector('.sunster-rvac-faq-categories__list');
    if (!categoryList || categoryList.scrollWidth <= categoryList.clientWidth) return;

    activeButton.scrollIntoView({
      behavior,
      block: 'nearest',
      inline: 'center',
    });
  }

  function setActiveCategory(section, categoryKey) {
    const buttons = section.querySelectorAll('[data-category-key]');
    const items = section.querySelectorAll('[data-faq-category]');
    const empty = section.querySelector('[data-faq-empty-state]');
    let activeButton = null;
    let visibleCount = 0;

    buttons.forEach((button) => {
      const isActive = button.dataset.categoryKey === categoryKey;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive) activeButton = button;
    });

    items.forEach((item) => {
      const isVisible = item.dataset.faqCategory === categoryKey;
      item.classList.toggle('hidden', !isVisible);
      if (!isVisible) item.removeAttribute('open');
      if (isVisible) visibleCount += 1;
    });

    if (empty) {
      empty.classList.toggle('hidden', visibleCount > 0);
    }

    scrollActiveCategoryIntoView(section, activeButton, section.dataset.faqReady === 'true' ? 'smooth' : 'auto');
  }

  function initFaqSection(section) {
    if (!section || section.dataset.faqReady === 'true') return;

    const buttons = section.querySelectorAll('[data-category-key]');
    const items = section.querySelectorAll('[data-faq-category]');
    if (!buttons.length || !items.length) return;

    const initialKey = [...buttons].find((button) => button.classList.contains('is-active'))?.dataset.categoryKey
      || buttons[0].dataset.categoryKey;

    setActiveCategory(section, initialKey);

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        setActiveCategory(section, button.dataset.categoryKey);
      });
    });

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });

    section.dataset.faqReady = 'true';
  }

  function initFaq(root = document) {
    root.querySelectorAll('[data-sunster-rvac-faq]').forEach(initFaqSection);
  }

  document.addEventListener('DOMContentLoaded', () => initFaq());
  document.addEventListener('shopify:section:load', (event) => initFaq(event.target));
})();
